module.exports = __webpack_public_path__ + "img/building5.fadecb61.jpg";